import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import CloseIcon from "../../../../SMARTCITY/assets/svg/components/CloseIcon";
import AddCircle from "../../../../SMARTCITY/assets/svg/components/AddCircle";
import * as Icon from "../smartiscity/Icons";
import { useAllContexts } from "../../../hooks/useAllContexts";

import "./NewRouteFormStyles.css";
import { Collapse, Table } from "antd";
import { StepsColumns } from "../utils";
import { createNewRoute } from "../../../services/services";
import { useAuth } from "../../../hooks/UserAuthProvider";
import ViewModal from "../container/ViewModal";
import {
  LoadingRise,
  LoadingDot,
  LoadingCircle,
  LoadingClock,
} from "../../UI/spinners/LoadingSpinners";

const { Panel } = Collapse;

const NewRouteForm = ({ showNewRouteForm, mapData }) => {
  const [newRouteName, setNewRouteName] = useState("");
  const [newRouteCategory, setNewRouteCategory] = useState("");
  const [newRouteStartPosition, setNewRouteStartPosition] = useState("");
  const [newRouteEndPosition, setNewRouteEndPosition] = useState("");
  const [isDraggingStep, setIsDraggingStep] = useState(false);

  const [submitLoading, setSubmitLoading] = useState(false);
  const [ShowSubmitModal, setShowSubmitModal] = useState(false);
  const [submitMessage, setSubmitMessage] = useState("");

  const { newRouteData, ameaRoutesCategories } = useAllContexts();
  const { tokens } = useAuth();

  const dragStep = useRef(0);
  const draggedOverStep = useRef(0);

  useEffect(() => {
    if (newRouteData?.get) {
      setNewRouteStartPosition(newRouteData?.get?.start?.address ?? "");
      setNewRouteEndPosition(newRouteData?.get?.end?.address ?? "");
    }
  }, [newRouteData?.refreshed]);

  const handleSort = () => {
    const tempSteps = newRouteData?.get.steps;
    const baseStep = tempSteps[dragStep.current];
    tempSteps[dragStep.current] = tempSteps[draggedOverStep.current];
    tempSteps[draggedOverStep.current] = baseStep;
    newRouteData?.updateStepOrder(tempSteps);
  };

  const handleSubmit = async () => {
    const newRoute = {
      title: newRouteName,
      category: newRouteCategory,
      start: newRouteData?.get?.start?.coordinates ?? {
        latitude: 40.653582,
        longitude: 22.922504,
      },
      end: newRouteData?.get?.end?.coordinates ?? {
        latitude: 40.653582,
        longitude: 22.922504,
      },
      infrastructures: newRouteData?.get.steps?.map((step, id) => step.id),
    };
    setSubmitLoading(true);
    await createNewRoute(newRoute, tokens.accessToken)
      .then((response) => {
        setSubmitLoading(false);
        setSubmitMessage("Η αποθήκευση της διαδρομής ολοκληρόθηκε επιτυχώς.");
        setShowSubmitModal(true);
      })
      .catch((error) => {
        setSubmitLoading(false);
        setSubmitMessage(
          "Υπήρξε κάποιο πρόβλημα κατά την αποθήκευση της διαδρομής. Παρακαλώ δοκιμάστε αργότερα."
        );
        setShowSubmitModal(true);
      });
  };

  const renderOptions = () => {
    return ameaRoutesCategories?.get.map((category, id) => {
      return (
        <option id={`route_category_${id}`} value={category.id}>
          {category.name}
        </option>
      );
    });
  };

  const renderSteps = () => {
    return newRouteData?.get.steps?.map((step, index) => (
      <div
        key={`step_${index}`}
        style={{
          paddingInline: "20px",
          height: "fit-content",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: "20px",
          position: "relative",
          paddingBlock: "4px",
          border: isDraggingStep
            ? dragStep.current !== index
              ? "1px solid rgba(0, 0, 0, 0.2)"
              : null
            : null,
        }}
        draggable
        onDragStart={() => {
          dragStep.current = index;
          setIsDraggingStep(true);
        }}
        onDragEnter={() => (draggedOverStep.current = index)}
        onDragEnd={() => {
          handleSort();
          setIsDraggingStep(false);
        }}
        onDragOver={(e) => e.preventDefault()}
      >
        {newRouteData?.get.steps.length - 1 !== index && (
          <div
            style={{
              width: "2px",
              height: "110%",
              backgroundColor: "lightgray",
              position: "absolute",
              top: "30px",
              left: "45px",
            }}
          ></div>
        )}
        <div style={{ position: "relative", cursor: "grab" }}>
          <p
            style={{
              fontSize: "20px",
              color: "white",
              position: "absolute",
              top: "6px",
              left: index > 8 ? "30% " : "40%",
              marginBottom: "4px",
            }}
          >
            {index + 1}
          </p>
          <img src={Icon.baseMarker} />
        </div>
        <div>
          <p>{step.title}</p>
          <p>{step.subTitle}</p>
        </div>
        <div
          style={{
            background: "#373B40",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginLeft: "auto",
            width: "14px",
            height: "14px",
            padding: "4px",
            borderRadius: "20px",
            cursor: "pointer",
          }}
          onClick={() => {
            newRouteData.removeStep(step);
          }}
        >
          <CloseIcon width="10px" color="white" />
        </div>
      </div>
    ));
  };

  return (
    <NewRouteContainer $isVisible={showNewRouteForm.get}>
      <LeftSideHeader
        style={{
          alignItems: "center",
          justifyContent: "space-between",
          paddingInline: "30px",
        }}
        $bgColor={mapData.bgColor}
      >
        <p>Δημιουργία Διαδρομής</p>
        <div
          onClick={() => {
            newRouteData.clearRoute();
            showNewRouteForm.set(false);
          }}
          style={{
            cursor: "pointer",
            width: "fit-content",
            height: "fit-content",
          }}
        >
          <CloseIcon width="16" height="16" />
        </div>
      </LeftSideHeader>
      <ContentWrapper>
        <Collapse
          accordion
          bordered={false}
          defaultActiveKey={["panel-1"]}
          style={{ width: "100%" }}
        >
          <Panel header="Πληροφορίες Διαδρομής" key="panel-1">
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                gap: "10px",
                paddingBlock: "30px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  backgroundColor: "#fff",
                  border: "1px solid #00000029",
                  borderRadius: "2px",
                }}
              >
                <div style={{ width: "20px", padding: "5px" }}>
                  <span> </span>
                </div>
                <NewRouteFormInput
                  // prefix={}
                  placeholder="Ονομα διαδρομής"
                  onChange={(event) => setNewRouteName(event.target.value)}
                  value={newRouteName}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  backgroundColor: "#fff",
                  border: "1px solid #00000029",
                  borderRadius: "2px",
                }}
              >
                <div style={{ width: "20px", padding: "5px" }}>
                  <span> </span>
                </div>
                <select
                  required
                  onChange={(event) => {
                    setNewRouteCategory(event.target.value);
                  }}
                  style={{
                    width: "264px",
                    border: "1px solid #00000029",
                    borderRadius: "2px",
                    height: "50px",
                    border: "none",
                    paddingBlock: "0 !important",

                    outline: "none",
                    fontSize: "16px",
                    fontWeight: "400",
                    lineHeight: "24px",
                    letterSpacing: "0.5%",
                    color:
                      newRouteCategory === ""
                        ? "rgba(0, 0, 0, 0.4)"
                        : "#373b40",
                    backgroundColor: "transparent",
                  }}
                  name="pets"
                  id="pet-select"
                  defaultValue=""
                >
                  <option value="">Επιλέξτε κατηγορία διαδρομής</option>
                  {renderOptions()}
                  {/* <option value="Διαδρομή σε δημόσιο κτήριο">
                    Διαδρομή σε δημόσιο κτήριο
                  </option>
                  <option value="Διαδρομή σε χώρο πολιτισμού">
                    Διαδρομή σε χώρο πολιτισμού
                  </option>
                  <option value="Πολιτιστική διαδρομή">
                    Πολιτιστική διαδρομή
                  </option> */}
                </select>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  backgroundColor: "#fff",
                  border: "1px solid #00000029",
                  borderRadius: "2px",
                }}
              >
                <div
                  style={{
                    width: "20px",
                    padding: "5px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <img src={Icon.myLocation} width="20px" />
                </div>
                <NewRouteFormInput
                  // prefix={}
                  placeholder="Επιλέξτε σημείο εκκίνησης"
                  onChange={(event) =>
                    setNewRouteStartPosition(event.target.value)
                  }
                  value={newRouteStartPosition}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  backgroundColor: "#fff",
                  border: "1px solid #00000029",
                  borderRadius: "2px",
                }}
              >
                <div
                  style={{
                    width: "20px",
                    padding: "5px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <img src={Icon.locationOn} width="16px" />
                </div>
                <NewRouteFormInput
                  // prefix={}
                  placeholder="Επιλέξτε τον προορισμό σας"
                  onChange={(event) =>
                    setNewRouteEndPosition(event.target.value)
                  }
                  value={newRouteEndPosition}
                />
              </div>
            </div>
          </Panel>
          {newRouteData?.get && (
            <Panel header="Επιλογή Υποδομών" key="panel-2">
              {newRouteData?.get.steps?.length === 0 ? (
                <div
                  style={{
                    maxWidth: "100%",
                    height: "fit-content",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "20px",
                    padding: "30px 20px",
                  }}
                >
                  <AddCircle color="#686868" />
                  <p
                    style={{
                      textAlign: "center",
                      fontSize: "16px",
                      fontWeight: "400",
                      lineHeight: "24px",
                      letterSpacing: "0.5%",
                    }}
                  >
                    Παρακαλώ επιλέξτε τις υποδομές από τις οποίες θέλετε να
                    περάσετε
                  </p>
                </div>
              ) : (
                <StepsContainer>{renderSteps()}</StepsContainer>
                // <Table
                //   dataSource={renderSteps()}
                //   columns={StepsColumns}
                //   bordered={false}
                //   showHeader={false}
                //   footer={null}
                //   pagination={false}
                // />
              )}
            </Panel>
          )}
        </Collapse>
        <div
          style={{
            width: "70%",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            // marginTop: "10px",
          }}
        >
          <ActionButton
            style={{ backgroundColor: "transparent", color: "#373B4099" }}
            onClick={() => showNewRouteForm.set(false)}
          >
            Ακύρωση
          </ActionButton>
          <ActionButton onClick={() => handleSubmit()}>
            {submitLoading ? (
              <LoadingDot color="#0000007f" size={20} css={{}} />
            ) : (
              "Αποθήκευση"
            )}
          </ActionButton>
        </div>
      </ContentWrapper>
      <ViewModal
        modalStatus={ShowSubmitModal}
        title="Κατάσταση Αποθήκευσης"
        closeModal={() => {
          newRouteData.clearRoute();
          showNewRouteForm.set(false);
          setShowSubmitModal(false);
        }}
      >
        <p>{submitMessage}</p>
      </ViewModal>
    </NewRouteContainer>
  );
};

export default NewRouteForm;

const LeftSideHeader = styled.div`
  background-color: ${(props) => props.$bgColor};
  height: 90px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  font-weight: 400px;
  line-height: 25px;
`;

const NewRouteContainer = styled.div`
  display: ${(props) => (props.$isVisible ? "block" : "none")};
  transition: all 1s ease;
`;

const RoutesContainer = styled.div`
  display: ${(props) => (props.$isVisible ? "none" : "block")};
  transition: all 1s ease;
`;

const NewRouteFormInput = styled.input`
  height: 50px;
  border: none;
  padding-block: 0 !important;
  width: 260px;
  outline: none;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.5%;
  color: #373b40;
  background-color: transparent;
  &::placeholder {
    color: rgba(0, 0, 0, 0.4);
    opacity: 1; /* Firefox */
  }
`;

const ContentWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: calc(100vh - 350px);
  align-items: center;
  gap: 10px;
  margin: 0 auto;
`;

const ActionButton = styled.button`
  position: relative;
  border-radius: 12px;
  background-color: #27aae1;
  width: 120px;
  height: 40px;
  // padding: 10px 16px;
  color: #000;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  &:hover {
    background-color: #4bc7fa;
  }
  transition: all 0.6s ease;
`;

const StepsContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 30px;
  height: 400px;
  overflow-y: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none; /* Internet Explorer and Edge */
  scrollbar-width: none; /* Firefox */
`;
